import { CssBaseline } from "@mui/material";
import React, { useContext, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import Login from "../Login";
import NavBar from "../NavBar";
import useStyles from "./styles";
import { useDispatch, useSelector } from "react-redux";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { login as loginAction } from "../../features/authSlice";
import CompareFiles from "../CompareReport";
import CurrentScanList from "../CurrentScanList";
import ExportReports from "../ExportReports";
import TodaysReport from "../TodaysReport";
import ScanQR from "../ScanQR/indesx";
import Associations from "../Associations";
import UsageReport from "../UsageReport/usageReport";
import DailyUsageReport from "../DailyUsageReport";
import PageNotFound from "../PageNotFound";
import { MyContext } from "../ContextApi";
import { initGA, trackPageView } from "../GoogleAnalytics";

const App = () => {
  const classes = useStyles();
  const authStatus = useSelector((state) => state.auth.status);
  const dispatch = useDispatch();
  const { getDecryptedSessionItem } = useContext(MyContext);

  const location = useLocation();
  // console.log("location", location.pathname);
  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    // Track page view on route change
    trackPageView(location.pathname + location.search);
  }, [location]);
  useEffect(() => {
    checkUserLogin();
  }, []);
  

  const checkUserLogin = () => {
    if (sessionStorage["username"]) {
      // console.log("updating redux");
      dispatch(loginAction());
    }
  };

  return (
    <div className={classes.root}>
      <CssBaseline>
        {location.pathname !== "/" && <NavBar />}
        <main className={classes.content}>
          <div className={classes.toolbar}></div>

          <Routes>
            <Route path="/" element={<Login />}></Route>
            {/* <Route path="/register" element={<Register />}></Route>  */}
            {getDecryptedSessionItem("clientId") && (
              <>
                <Route path="/scan-qr" element={<ScanQR />}></Route>
                <Route
                  path="/current-scans"
                  element={<CurrentScanList />}
                ></Route>
                <Route path="/todays-report" element={<TodaysReport />}></Route>
                <Route
                  path="/export-reports"
                  element={<ExportReports />}
                ></Route>
                <Route path="/compare-files" element={<CompareFiles />}></Route>
                <Route path="/uploads" element={<Associations />}></Route>
                <Route path="/usage" element={<UsageReport />}></Route>
                <Route
                  path="/daily-usage"
                  element={<DailyUsageReport />}
                ></Route>
              </>
            )}

            <Route path="*" element={<PageNotFound />}></Route>
          </Routes>
        </main>
      </CssBaseline>
      <ToastContainer autoClose={1000} />
    </div>
  );
};

export default App;
